import React from 'react';
import Earning from '../../../assets/dashboard/Earning';

export default function ActualPNLCard({ amount }) {
    return (
        <div className='p-5 border-2 border-light rounded-[10px] cursor-pointer h-full'>
            <div className='flex flex-col items-center justify-center gap-2 h-full'>
                <div className='flex justify-center items-center bg-primary-light w-[45px] h-[45px] rounded-lg'>
                    <Earning color="#00727D" />
                </div>
                <div className='text-center'>
                    <p className='text-title font-semibold capitalize'>Actual P/L</p>
                    <p className='text-title font-bold primary'>$ {amount || 0}</p>
                </div>
            </div>
        </div>
    )
}